var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    viewBox: "0 0 84 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-8.000000, -2.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    stroke: "currentColor",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    points: "39 0 0 22 0 67 39 90 78 68 78 23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 50.5 30.3 L 50.5 35.3 L 42 35.3 L 42 52 C 42 55.5 41 57.5 38 59 C 35.5 60.3 32 60.8 28 60.5 L 28 55.5 C 31 55.7 33.5 55.5 35 54.8 C 36.5 54 37 52.8 37 51 L 37 35.3 L 28.5 35.3 L 28.5 30.3 L 50.5 30.3 Z",
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.6a2c50a00423281edd1a7f834b6bed48.svg";
export { ForwardRef as ReactComponent };